import React, {FC, ReactNode} from 'react';

import classNames from 'classnames';

import {CTP_BADGES_REDESIGN} from '../constants';

import s from './badge.scss';

export enum BADGE_VARIATION {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}

export const BADGE_CLASSNAMES: Record<string, string> = {
    [CTP_BADGES_REDESIGN.LUXURY]: s.luxury,
    [CTP_BADGES_REDESIGN.PREMIUM]: s.premium,
    [CTP_BADGES_REDESIGN.SALE]: s.sale,
};

export type BadgeVariationType = BADGE_VARIATION.PRIMARY | BADGE_VARIATION.SECONDARY;

type PropsType = {
    id: number;
    variation?: BadgeVariationType;
    content: ReactNode;
    className?: string;
};

/**
 * Badge UI component
 */
export const Badge: FC<PropsType> = ({className, content, variation = BADGE_VARIATION.PRIMARY}) => {
    return (
        <span
            className={classNames(s.badge, className, {
                [s.primary]: variation === BADGE_VARIATION.PRIMARY,
                [s.secondary]: variation === BADGE_VARIATION.SECONDARY,
            })}
        >
            {content}
        </span>
    );
};
